import { render, staticRenderFns } from "./Ventilation2.vue?vue&type=template&id=1ab2e596&"
import script from "./Ventilation2.vue?vue&type=script&lang=js&"
export * from "./Ventilation2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports